import React from 'react'
import classes from './Modal.module.scss'
import Close from '@mui/icons-material/Close'
import { ItineraryCarRental } from '../../../atom/Types'
import moment from 'moment'
import { CarTransmissin, CloseButtonSvg, DateSvg, LocationSvg } from '../../../constants/resources'
import { Time, checkSpacing } from '../../../atom/utilities/function'


interface props {
    activeCarRental: ItineraryCarRental | {}
    handleCarRental: (n: ItineraryCarRental[], m: string) => void
    setActiveCarRental: React.Dispatch<React.SetStateAction<{} | ItineraryCarRental>>
    carDetails: ItineraryCarRental[]
    buliddata: any


}
const CarModal: React.FC<props> = ({ activeCarRental, handleCarRental, carDetails, setActiveCarRental, buliddata }) => {
    const handleSelection = (car: ItineraryCarRental) => {
        if ('id' in activeCarRental && car.id === activeCarRental.id)
            setActiveCarRental({})
        else
            setActiveCarRental(car)
    }


    return (
        <div className={classes.ModalBackground}>
            <div className={classes.scrollModalContent}>
                <div className={classes.Flex}>
                    <div className={classes.modalTop}>
                        <div className={classes.header}>Select a car</div>
                        <div className={classes.flightTop}>
                            {Array.isArray(carDetails) && <button className={classes.CloseButton} onClick={() => handleCarRental(carDetails, 'close')}>
                                <Close className={classes.closesvg} />
                            </button>}
                        </div>
                    </div>
                    <hr />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', }}>
                    <div className={classes.carScrollContainer}>

                        {carDetails?.map((car, index) => {
                            return <div key={index} className={'id' in activeCarRental && car.id === activeCarRental?.id ? classes.mainViewSelected : classes.mainView}>
                                <div className={classes.displayView}>
                                    <div className={classes.carContainer}>
                                        <div className={classes.carHead}>{car?.carRental?.companyName}</div>
                                        <div className={classes.carHead} style={{
                                            color: "var(--blue-text, #0279CF)",
                                        }}>
                                            <div>{car?.carBrand}</div>
                                            <div style={{ fontWeight: "500", color: "var(--grey-600, #758191)" }}>
                                                or similar | economy class
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", gap: '4px', flexDirection: 'row', }}>
                                            {car?.carAmenities.length > 0 ? <div className={classes.carProperties}><span>
                                                <CarTransmissin />
                                            </span>{car?.carAmenities[0] === 'AutomaticTransmission' ? 'Automatic' : 'Manual'}</div> : null}
                                            {car?.doorCount !== 0 ? <div className={classes.carProperties}><span>
                                                <CarTransmissin />
                                            </span>
                                                {car?.doorCount}</div> : null}
                                            {car?.passengerCount !== 0 ? <div className={classes.carProperties}><span>
                                                <CarTransmissin />
                                            </span>{car?.passengerCount}</div> : null}
                                            {car?.luggageCount !== 0 ? <div className={classes.carProperties}><span>
                                                <CarTransmissin />
                                            </span>{car?.luggageCount}</div> : null}
                                        </div>
                                        <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <DateSvg />
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Pick-up date</div>
                                                <div>{moment.utc(car?.pickUpDate).format('MMM DD')}</div>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Pick-up time</div>
                                                <div style={{ fontSize: "16px", }}>{Time(car.pickUpTime)}</div>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <DateSvg />
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Drop-off date</div>
                                                <div>{moment.utc(car?.dropOffDate).format('MMM DD')}</div>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Drop-off time</div>
                                                <div style={{ fontSize: "16px", }}>{Time(car?.dropOffTime)}</div>
                                            </div>
                                        </div>
                                        {car?.pickUpLocation !== "" ? <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <LocationSvg width={"13px"} height={"12px"} />

                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Pick-up location</div>
                                                <div style={{ width: "272px", fontSize: '16px' }}>{car?.pickUpLocation}</div>
                                            </div>
                                        </div> : null}

                                        {car?.dropOffLocation !== "" ? <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <LocationSvg width={"13px"} height={"12px"} />

                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Drop-off location</div>
                                                <div style={{ width: "272px", fontSize: '16px' }}>{car?.dropOffLocation}</div>
                                            </div>
                                        </div> : null}

                                    </div>
                                    <div className={classes.carPrice}>
                                        <p className={classes.price}>{car?.price !== null && car?.price !== 0 ? `$ ${car?.price}` : null}</p>
                                        {car?.comment && <p style={{ textAlign: "left" }} dangerouslySetInnerHTML={{ __html: checkSpacing(car?.comment) ? car?.comment : "" }}></p>}
                                        <p style={{ fontSize: '14px', color: '#FF3566' }}>{car?.cancellationPolicy}</p>
                                    </div>
                                </div>
                                {buliddata.type === 'Proposal' && <div style={{ display: 'flex', justifyContent: 'center' }}><button className={'id' in activeCarRental && car?.id === activeCarRental?.id ? classes.subButtonSelected : classes.subButton} onClick={() => handleSelection(car)}>{'id' in activeCarRental && car?.id === activeCarRental?.id ? <span>
                                    <CloseButtonSvg />
                                    Clear Choice</span> : "Choose"}</button></div>}
                            </div>
                        })}
                    </div>
                </div>
                {buliddata.type === 'Proposal' ? <div className={classes.carButton}><button disabled={Object.keys(activeCarRental).length > 0 ? false : true} onClick={() => handleCarRental(carDetails, 'choose')}>Confirm</button></div>
                    :
                    carDetails[0]?.selected ?
                        <div className={classes.ClearChoice}>
                            <button onClick={() => { handleCarRental(carDetails, 'choose') }}>
                                <Close style={{ marginRight: "8px", color: "#FF3566", transform: "scale(0.8)" }} />
                                Clear choice
                            </button>
                        </div> :
                        <div className={classes.Choose}>
                            <button onClick={() => handleCarRental(carDetails, 'choose')}>
                                Choose
                            </button>
                        </div>
                }


            </div>
        </div>
    )
}

export default CarModal